import './style.css'

// ========================================
// CONFIGURATION
// ========================================
const CONTACT = {
  name: 'Amaru Adolfo Luque Pacheco',
  title: 'Owner of Mechamaru',
  company: 'Mechamaru',
  email: 'Amaru@mechamaru.nl',
  phone: '+49 015235816415',
  whatsapp: '+49015235816415',
  linkedin: 'https://www.linkedin.com/in/amaruluque',
  website: window.location.origin + '/',
}

// ========================================
// Language Switcher
// ========================================
const langSelect = document.getElementById('langSelect')
if (langSelect) {
  langSelect.addEventListener('change', (e) => {
    const newLang = e.target.value
    const path = location.pathname.replace(/^\/[a-z]{2}\//, '/')
    location.href = '/' + newLang + (path || '/')
  })
}

// ========================================
// Safe DOM helpers
// ========================================
function setHref(id, url) {
  const el = document.getElementById(id)
  if (el) el.href = url
}

function setText(id, text) {
  const el = document.getElementById(id)
  if (el) el.textContent = text
}

// ========================================
// Update contact info in the page
// ========================================
setText('displayName', CONTACT.name)
setHref('whatsappBtn', 'https://wa.me/' + String(CONTACT.whatsapp).replace(/\+/g, ''))
setHref('emailBtn', 'mailto:' + CONTACT.email)
setHref('callBtn', 'tel:' + String(CONTACT.phone).replace(/\s/g, ''))

// ========================================
// Generate QR Code pointing to this share page
// ========================================
const shareUrl = window.location.href
const qrContainer = document.getElementById('qrcode')

if (qrContainer) {
  const qrScript = document.createElement('script')
  qrScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js'
  qrScript.onload = () => {
    if (typeof QRCode !== 'undefined') {
      new QRCode(qrContainer, {
        text: shareUrl,
        width: 200,
        height: 200,
        colorDark: '#0A1628',
        colorLight: '#F5F5F0',
        correctLevel: QRCode.CorrectLevel.H,
      })
    }
  }
  document.head.appendChild(qrScript)
}

// ========================================
// Update "Visit Full Website" link
// ========================================
const websiteBtn = document.querySelector('a[href="../"]')
if (websiteBtn) {
  const pathParts = location.pathname.split('/')
  const currentLang = pathParts[1]
  const supported = ['en', 'es', 'nl', 'de', 'zh']
  if (supported.includes(currentLang)) {
    websiteBtn.href = '/' + currentLang + '/'
  }
}

// ========================================
// Floating particles
// ========================================
(function createParticles() {
  const container = document.getElementById('particles')
  if (!container) return
  for (let i = 0; i < 15; i++) {
    const p = document.createElement('div')
    p.className = 'particle'
    p.style.cssText = `
      position: absolute;
      width: ${2 + Math.random() * 2}px;
      height: ${2 + Math.random() * 2}px;
      background: #C9A96E;
      border-radius: 50%;
      opacity: ${0.1 + Math.random() * 0.2};
      left: ${Math.random() * 100}%;
      top: ${Math.random() * 100}%;
      animation: float ${5 + Math.random() * 6}s ease-in-out infinite;
      animation-delay: ${Math.random() * 5}s;
    `
    container.appendChild(p)
  }
})()

// ========================================
// vCard download
// ========================================
window.downloadVCard = function downloadVCard() {
  const vCard = `BEGIN:VCARD
VERSION:3.0
FN:${CONTACT.name}
TITLE:${CONTACT.title}
ORG:${CONTACT.company}
EMAIL:${CONTACT.email}
TEL;TYPE=CELL:${CONTACT.phone}
URL:${CONTACT.website}
URL;TYPE=LinkedIn:${CONTACT.linkedin}
NOTE:Owner of Mechamaru - The Linear Oasis investment opportunity
END:VCARD`

  const blob = new Blob([vCard], { type: 'text/vcard' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = 'linear-oasis-contact.vcf'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
